import { map } from "lodash";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database, storage } from "../../config/firebaseConfig";

export const fetchWorkordersAsync = createAsyncThunk(
  "workorders/fetchWorkorders",
  async (id, thunkAPI) => {
    try {
      if (!id) {
        await database.ref("jobs/workorders").on("value", (snapshot) => {
          return thunkAPI.dispatch(fetchWorkorders(snapshot.val()));
        });
      } else {
        await database.ref(`jobs/workorders/${id}`).on("value", (snapshot) => {
          return thunkAPI.dispatch(fetchWorkorders({ [id]: snapshot.val() }));
        });
      }
      return;
    } catch (e) {
      throw e;
    }
  }
);

export const unfetchWorkordersAsync = createAsyncThunk(
  "workorders/unfetchWorkorders",
  async (id, thunkAPI) => {
    try {
      if (!id) {
        await database.ref("jobs/workorders").off();
        return;
      } else {
        await database.ref(`jobs/workorders/${id}`).off();
      }
    } catch (e) {
      throw e;
    }
  }
);

export const fetchDeliveryTicketsAsync = createAsyncThunk(
  "workorders/fetchDeliveryTickets",
  async (id, thunkAPI) => {
    try {
      if (!id) {
        await database.ref("jobs/deliveryTickets").on("value", (snapshot) => {
          return thunkAPI.dispatch(fetchDeliveryTickets(snapshot.val()));
        });
      } else {
        await database
          .ref(`jobs/deliveryTickets/${id}`)
          .on("value", (snapshot) => {
            return thunkAPI.dispatch(
              fetchDeliveryTickets({ [id]: snapshot.val() })
            );
          });
      }
      return;
    } catch (e) {
      throw e;
    }
  }
);

export const unfetchDeliveryTicketsAsync = createAsyncThunk(
  "workorders/unfetchDeliveryTickets",
  async (id, thunkAPI) => {
    try {
      if (!id) {
        await database.ref("jobs/deliveryTickets").off();
        return;
      } else {
        await database.ref(`jobs/deliveryTickets/${id}`).off();
      }
    } catch (e) {
      throw e;
    }
  }
);

const slice = createSlice({
  name: "jobs",
  initialState: {
    workorders: {},
    deliveryTickets: {},
    status: "idle",
  },
  reducers: {
    fetchWorkorders: (state, action) => {
      state.workorders = { ...action.payload };
      state.status = "idle";
    },
    fetchDeliveryTickets: (state, action) => {
      state.deliveryTickets = { ...action.payload };
      state.status = "idle";
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchWorkordersAsync.pending, (state) => {
          state.status = "pending";
        })
        .addCase(fetchWorkordersAsync.fulfilled, (state, action) => {
          state.status = "idle";
          // state.logs.maintenance = action.payload
        })
        .addCase(fetchDeliveryTicketsAsync.pending, (state) => {
          state.status = "pending";
        })
        .addCase(fetchDeliveryTicketsAsync.fulfilled, (state, action) => {
          state.status = "idle";
          // state.logs.maintenance = action.payload
        });
    },
  },
});

export default slice.reducer;

const { fetchWorkorders, fetchDeliveryTickets } = slice.actions;
